import type { Appointment } from '@medplum/fhirtypes';
import { ZOOM_SIDEBAR_SESSION_NOTES_EXT } from '@unify/fhir-model/constants';

export function getZoomSidebarSessionNotes(appointment: Appointment): string {
  return appointment.extension?.find((e) => e.url === ZOOM_SIDEBAR_SESSION_NOTES_EXT)?.valueString?.trim() ?? '';
}

export function setZoomSidebarSessionNotes(appointment: Appointment, notes: string): Appointment {
  const trimmed = notes.trim();
  const others = (appointment.extension ?? []).filter((e) => e.url !== ZOOM_SIDEBAR_SESSION_NOTES_EXT);
  if (!trimmed) {
    return { ...appointment, extension: others.length > 0 ? others : undefined };
  }
  return {
    ...appointment,
    extension: [...others, { url: ZOOM_SIDEBAR_SESSION_NOTES_EXT, valueString: trimmed }],
  };
}
